import { makeStyles } from 'tss-react/mui';
export const styles = (theme) => ({
    root: {
        textAlign: 'center',
        padding: `${theme.spacing(6)} 0`,
    },
    image: {
        maxWidth: '100%',
        padding: `${theme.spacing()} 0`,
    },
    body: {},
    title: {
        fontSize: 20,
        color: theme.palette.primary.main,
        padding: `${theme.spacing()} 0`,
    },
    smallTitle: {
        fontSize: 15,
    },
    message: {
        padding: `${theme.spacing()} 0`,
        fontSize: 15,
        color: theme.palette.grey[700],
    },
});
export const useStyles = makeStyles()(styles);
//# sourceMappingURL=EmptyState.styles.js.map